import form from './form';
import table from './table';
export default {
  layout: 'insurance-layout',
  grid: 'insurance-grid',
  table,
  form,
};
